/* Booster Clash V2 : comportements partagés de la page concours.
   - <bc2-video data-video="URL ou ID YouTube"> : l'iframe n'est créée qu'au clic
     (page légère, aucun cookie YouTube avant l'action du visiteur).
   - <bc2-onglets> : onglets accessibles (flèches clavier), bascule des panneaux.
   - BC2.tiers() : lecture unique du compteur serveur /apps/club/tiers. */
(() => {
  if (window.BC2) return;

  // Anciennes ancres techniques (#bc2-packs…) déjà partagées dans des e-mails :
  // on les remplace dans l'adresse par le nom lisible, puis on va à la section.
  const ANCIENNES_ANCRES = {
    'bc2-hero': 'accueil', 'bc2-lots': 'lots', 'bc2-zoom': 'details-lots', 'bc2-comment': 'comment-ca-marche',
    'bc2-jeu': 'jeu', 'bc2-createurs': 'createurs', 'bc2-tirage': 'tirage', 'bc2-organisateurs': 'partenaires',
    'bc2-faq': 'faq', 'bc2-packs': 'packs',
  };
  function corrigerAncre() {
    const nouvelle = ANCIENNES_ANCRES[decodeURIComponent(location.hash.slice(1))];
    if (!nouvelle) return;
    history.replaceState(null, '', `${location.pathname}${location.search}#${nouvelle}`);
    const cible = document.getElementById(nouvelle);
    if (cible) cible.scrollIntoView({ block: 'start' });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', corrigerAncre, { once: true });
  else corrigerAncre();
  window.addEventListener('hashchange', corrigerAncre);

  function idYouTube(v) {
    if (!v) return null;
    const m = String(v).match(/(?:youtu\.be\/|v=|embed\/|shorts\/)([\w-]{11})/);
    if (m) return m[1];
    return /^[\w-]{11}$/.test(v) ? v : null;
  }

  class Bc2Video extends HTMLElement {
    connectedCallback() {
      const bouton = this.querySelector(':scope > button');
      if (!bouton) return;
      const id = idYouTube(this.dataset.video);
      if (!id) {
        bouton.disabled = true;
        this.classList.add('bc2-video--vide');
        return;
      }
      bouton.addEventListener('click', () => {
        // Vignette trop petite pour regarder (ex. carte « Pourquoi un commissaire
        // de justice ? » en mobile) : la vidéo s'ouvre dans une fenêtre 16:9.
        if (this.getBoundingClientRect().width < 400) this.ouvrirFenetre(id);
        else if (!this.classList.contains('bc2-video--lecture')) this.lire(id);
      });
    }
    iframe(id) {
      const iframe = document.createElement('iframe');
      iframe.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0&playsinline=1`;
      iframe.title = this.dataset.titre || 'Vidéo';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      iframe.allowFullscreen = true;
      return iframe;
    }
    lire(id) {
      this.appendChild(this.iframe(id));
      this.classList.add('bc2-video--lecture');
    }
    ouvrirFenetre(id) {
      const dlg = document.createElement('dialog');
      dlg.className = 'bc2-video-fenetre';
      dlg.setAttribute('aria-label', this.dataset.titre || 'Vidéo');
      const cadre = document.createElement('div');
      cadre.className = 'bc2-video-fenetre__cadre';
      cadre.appendChild(this.iframe(id));
      const fermer = document.createElement('button');
      fermer.type = 'button';
      fermer.className = 'bc2-video-fenetre__fermer';
      fermer.setAttribute('aria-label', 'Fermer la vidéo');
      fermer.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
      dlg.append(cadre, fermer);
      // Fermeture (bouton, Échap, clic hors de la vidéo) : la fenêtre et la vidéo disparaissent
      const bouton = this.querySelector(':scope > button');
      dlg.addEventListener('close', () => { dlg.remove(); bouton?.focus({ preventScroll: true }); });
      fermer.addEventListener('click', () => dlg.close());
      dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });
      document.body.appendChild(dlg);
      dlg.showModal();
    }
  }
  if (!customElements.get('bc2-video')) customElements.define('bc2-video', Bc2Video);

  class Bc2Onglets extends HTMLElement {
    connectedCallback() {
      this.onglets = [...this.querySelectorAll('[role="tab"]')];
      this.onglets.forEach((o, i) => {
        o.addEventListener('click', () => this.activer(i));
        o.addEventListener('keydown', (e) => {
          const pas = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!pas) return;
          e.preventDefault();
          const n = (i + pas + this.onglets.length) % this.onglets.length;
          this.activer(n);
          this.onglets[n].focus();
        });
      });
    }
    activer(i) {
      this.onglets.forEach((o, j) => {
        const actif = i === j;
        o.setAttribute('aria-selected', String(actif));
        o.tabIndex = actif ? 0 : -1;
        const panneau = document.getElementById(o.getAttribute('aria-controls'));
        if (panneau) panneau.hidden = !actif;
      });
      this.dispatchEvent(new CustomEvent('bc2:onglet', { detail: { index: i }, bubbles: true }));
    }
  }
  if (!customElements.get('bc2-onglets')) customElements.define('bc2-onglets', Bc2Onglets);

  // Éditeur de thème : sélectionner un bloc dans la colonne le rend visible sur
  // la page (onglet affiché, question ouverte, carte amenée dans le carrousel,
  // message du bandeau affiché). Ces événements n'existent que dans l'éditeur.
  document.addEventListener('shopify:block:select', (e) => {
    const bloc = e.target;
    if (!(bloc instanceof Element)) return;
    const panneau = bloc.closest('[role="tabpanel"]');
    if (panneau && panneau.hidden) document.querySelector('[aria-controls="' + panneau.id + '"]')?.click();
    const question = bloc.matches('details') ? bloc : bloc.closest('details');
    if (question && !question.open) question.open = true;
    if (bloc.classList.contains('bc2-annonce__message')) {
      const bandeau = bloc.closest('bc2-annonce');
      if (bandeau && bandeau.messages) { bandeau.pause = true; bandeau.montrer(bandeau.messages.indexOf(bloc)); }
    }
    const piste = bloc.closest('.bc2-defile, [data-bc2-plein]');
    if (piste) requestAnimationFrame(() => bloc.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' }));
  });
  document.addEventListener('shopify:block:deselect', (e) => {
    const bandeau = e.target instanceof Element ? e.target.closest('bc2-annonce') : null;
    if (bandeau) bandeau.pause = false;
  });

  let promesseTiers = null;
  window.BC2 = {
    idYouTube,
    tiers() {
      if (!promesseTiers) {
        promesseTiers = fetch('/apps/club/tiers', { headers: { Accept: 'application/json' } })
          .then((r) => (r.ok && (r.headers.get('content-type') || '').includes('json') ? r.json() : null))
          .catch(() => null);
      }
      return promesseTiers;
    },
  };
})();

/* Lien qui ouvre un formulaire Klaviyo (ex. participation gratuite) :
   <a href="/" data-bc2-formulaire="Xk7C7i">…</a>. Sans Klaviyo, le lien mène à son href. */
(() => {
  document.addEventListener('click', (e) => {
    const lien = e.target.closest && e.target.closest('[data-bc2-formulaire]');
    if (!lien || !window._klOnsite) return;
    e.preventDefault();
    window._klOnsite.push(['openForm', lien.dataset.bc2Formulaire]);
  });
})();
